export default __webpack_public_path__ + "static/media/shape-2.601ba12e.png";